<template>
  <div class="warp">
    <TopBar></TopBar>
    <div class="head_top flex">
      <img src="@/assets/img/common/logo3.png" />
    </div>
    <div class="form">
      <van-form @submit="onSubmit">
        <div class="item">
          <img class="item_icon" src="@/assets/img/icons/username.png" />
          <van-field
            v-model="username"
            name="用户名"
            placeholder="请输入用户名"
            :rules="[{ required: true, message: '用户名不能为空！' }]"
          />
        </div>
        <div class="item">
          <img class="item_icon" src="@/assets/img/icons/password.png" />
          <van-field
            v-model="password"
            type="password"
            name="密码"
            placeholder="请输入密码"
            :rules="[
              {
                required: true,
                validator,
                message: '密码不能少于6位,包含数字和字母！'
              }
            ]"
          />
        </div>
        <div style="margin: 16px;">
          <van-button
            round
            block
            type="info"
            color="#e61723"
            native-type="submit"
            >提交</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>
<script>
import TopBar from '@/components/common/topBar'
import { Button } from 'vant'
import { Form } from 'vant'
import { Field } from 'vant'
import { encrypt } from '../../utils/encryption'

export default {
  components: {
    TopBar,
    [Button.name]: Button,
    [Form.name]: Form,
    [Field.name]: Field
  },
  data() {
    return {
      username: '',
      password: '',
      fromPath: ''
    }
  },
  created() {},
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例,将值传入fromPath
      vm.fromPath = from.path
    })
  },
  methods: {
    async onSubmit() {
      try {
        let userInfo = await this.$http.post('/auth/login', {
          username: this.username,
          password: encrypt(this.password)
        })
        localStorage.userInfo = JSON.stringify(userInfo)
        this.$toast.success('登录成功')
        this.$router.replace(this.fromPath)
      } catch (err) {
        console.log(err)
        this.$toast.fail('用户名或密码错误！')
      }
    },

    // 密码验证正则
    validator(val) {
      return /^(?=.*[a-z])(?=.*\d)[^]{6,}$/.test(val)
    }
  }
}
</script>

<style lang="less" scoped>
.warp {
  padding: 0.4rem;
}
.head_top {
  margin-top: 1.8667rem;
  margin-bottom: 1.0667rem;
}
.form {
  .item {
    display: flex;
    align-items: center;
    border-bottom: 0.0267rem solid #d9d9d9;
    margin-bottom: 1.0667rem;
    padding: 0.2667rem 0.1333rem;
  }
  .item_icon {
    width: 0.48rem;
    height: 0.48rem;
    margin-right: 0.4rem;
  }
}
/deep/.van-field__control {
  font-size: 0.4267rem;
  letter-spacing: 0.0267rem;
}
</style>
